import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const buildAutoReportBody = ({ frequency, coverage, sections, token }) => {
  const body = { frequency, token };
  if (coverage) body.coverage = coverage;
  if (sections) body.sections = sections;
  return body;
};

const autoReportApi = createApi({
  reducerPath: "autoReport",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  endpoints(builder) {
    return {
      previewUserAutoReport: builder.mutation({
        query: ({ id, frequency, coverage, sections, token }) =>
          apiFunction(
            buildAutoReportBody({ frequency, coverage, sections, token }),
            `/api/users/storageRoles/${id}/auto-report/preview`,
            "POST"
          ),
      }),
      sendUserAutoReport: builder.mutation({
        query: ({ id, frequency, coverage, sections, token }) =>
          apiFunction(
            buildAutoReportBody({ frequency, coverage, sections, token }),
            `/api/users/storageRoles/${id}/auto-report/send`,
            "POST"
          ),
      }),
      previewFirmAutoReport: builder.mutation({
        query: ({ id, frequency, coverage, sections, token }) =>
          apiFunction(
            buildAutoReportBody({ frequency, coverage, sections, token }),
            `/api/firms/storageRoles/${id}/auto-report/preview`,
            "POST"
          ),
      }),
      sendFirmAutoReport: builder.mutation({
        query: ({ id, frequency, coverage, sections, token }) =>
          apiFunction(
            buildAutoReportBody({ frequency, coverage, sections, token }),
            `/api/firms/storageRoles/${id}/auto-report/send`,
            "POST"
          ),
      }),
      saveFirmAutoReportConfig: builder.mutation({
        query: ({ id, autoReportMailConfig, token }) =>
          apiFunction(
            { autoReportMailConfig, token },
            `/api/firms/storageRoles/${id}/auto-report/config`,
            "PATCH"
          ),
      }),
    };
  },
});

export const {
  usePreviewUserAutoReportMutation,
  useSendUserAutoReportMutation,
  usePreviewFirmAutoReportMutation,
  useSendFirmAutoReportMutation,
  useSaveFirmAutoReportConfigMutation,
} = autoReportApi;

export { autoReportApi };
